// extracted by mini-css-extract-plugin
export default {"heading":"StudentMyAssessments_heading__+Y0Pb"};